export default __webpack_public_path__ + "static/media/cain6.de371a4c.jpg";